module.exports = __webpack_public_path__ + "img/UTHIST.e22334e9.png";